import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import type * as React from 'react';
import transcriptSpeakerUnassigned, {
	type TranscriptSpeakerUnassignedAction,
} from '@Application/Beneficiaries/Transcripts/Actions/transcriptSpeakerUnassigned';
import transcriptSpeakerUnassignmentFailed, {
	type TranscriptSpeakerUnassignmentFailedAction,
} from '@Application/Beneficiaries/Transcripts/Actions/transcriptSpeakerUnassignmentFailed';
import type { TranscriptSpeakerPayload } from '@Application/Beneficiaries/Transcripts/Actions/transcriptSpeakersFetched';
import type UnassignTranscriptSpeaker from '@Application/Beneficiaries/Transcripts/Commands/UnassignTranscriptSpeaker';
import { del } from '@Domain/Api';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions = TranscriptSpeakerUnassignedAction | TranscriptSpeakerUnassignmentFailedAction;

export default (command: UnassignTranscriptSpeaker) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await del<TranscriptSpeakerPayload>(
				`${buildSubjectApiPath(command.facilityId, command.subject)}/interviews/${command.interviewId}/transcript/speakers/${command.speakerId}/assignment`,
			);

			const action = transcriptSpeakerUnassigned(payload, command.interviewId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = transcriptSpeakerUnassignmentFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
